import { Injectable, signal } from "@angular/core";

const MASKING_STORAGE_KEY = "admin_masking_enabled";

@Injectable({
    providedIn: "root",
})
export class MaskingStore {
    readonly isMaskingEnabled = signal<boolean>(this.loadFromSession());

    private loadFromSession(): boolean {
        if (typeof sessionStorage === "undefined") return true;
        const stored = sessionStorage.getItem(MASKING_STORAGE_KEY);
        return stored === null ? true : stored === "true";
    }

    private saveToSession(value: boolean): void {
        if (typeof sessionStorage === "undefined") return;
        sessionStorage.setItem(MASKING_STORAGE_KEY, String(value));
    }

    enable() {
        this.isMaskingEnabled.set(true);
        this.saveToSession(true);
    }

    disable() {
        this.isMaskingEnabled.set(false);
        this.saveToSession(false);
    }

    toggle() {
        const newValue = !this.isMaskingEnabled();
        this.isMaskingEnabled.set(newValue);
        this.saveToSession(newValue);
    }
}
